import { Heading, TableHead, TableHeader, TableHeaderSelectAll, TableRow, Tooltip } from '@ksyos/design-system';
import type { IProcessActivityWithChecked } from '@frontend/components/interfaces';
import { getSelectedLanguage } from '@frontend/translate';

interface IPaymentsTableHeadProps {
    allPaymentItemsSelected: boolean;
    items: IProcessActivityWithChecked[];
    onSelectAllPaymentItems: (value: boolean) => void;
}

export function PaymentsTableHead(props: Readonly<IPaymentsTableHeadProps>) {
    const language = getSelectedLanguage();

    return (
        <TableHead>
            <TableRow>
                <TableHeader colSpan={8}>
                    <Heading size="medium">{language.request.activityDetails}</Heading>
                </TableHeader>
                <TableHeader colSpan={9}>
                    <Heading size="medium">{language.request.payoutDetails}</Heading>
                </TableHeader>
            </TableRow>
            <TableRow>
                {props.items.length ? (
                    <TableHeaderSelectAll
                        checked={props.items.some((item) => item.checked) || props.allPaymentItemsSelected}
                        indeterminate={!props.allPaymentItemsSelected}
                        onSelect={(event) => props.onSelectAllPaymentItems((event.target as HTMLInputElement).checked)}
                    />
                ) : (
                    <TableHeader />
                )}
                <TableHeader>{language.request.dateSent}</TableHeader>
                <TableHeader>{language.common.activity}</TableHeader>
                <TableHeader>{language.finance.institution}</TableHeader>
                <TableHeader>{language.practitioner.practitioner}</TableHeader>
                <TableHeader>{language.service.service}</TableHeader>
                <TableHeader>{language.common.processId}</TableHeader>
                <TableHeader>{language.finance.reasonNoPaymentShort}</TableHeader>
                <TableHeader>
                    <Tooltip content={language.finance.dateTooltip}>
                        <span>{language.common.date}</span>
                    </Tooltip>
                </TableHeader>
                <TableHeader>{language.finance.institution}</TableHeader>
                <TableHeader>{language.practitioner.practitioner}</TableHeader>
                <TableHeader>{language.organization.relationNumber}</TableHeader>
                <TableHeader>{language.common.profession}</TableHeader>
                <TableHeader>{language.finance.amount}</TableHeader>
                <TableHeader>{language.finance.runNumber}</TableHeader>
                <TableHeader>{language.finance.reprocessByShort}</TableHeader>
                <TableHeader>{language.finance.reprocessedOn}</TableHeader>
                <TableHeader></TableHeader>
            </TableRow>
        </TableHead>
    );
}
